(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('AutreActiviteDeleteController',AutreActiviteDeleteController);

    AutreActiviteDeleteController.$inject = ['$uibModalInstance', 'entity', 'AutreActivite'];

    function AutreActiviteDeleteController($uibModalInstance, entity, AutreActivite) {
        var vm = this;

        vm.autreActivite = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AutreActivite.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
